import React, { useEffect, useState } from 'react';

function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return '—';
  if (seconds < 60) return `${seconds}秒`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins < 60) return secs > 0 ? `${mins}分${secs}秒` : `${mins}分钟`;
  const hours = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return remainMins > 0 ? `${hours}小时${remainMins}分` : `${hours}小时`;
}

export default function AdminIPs() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const load = async (query) => {
    setLoading(true);
    setErr('');
    try {
      const url = new URL('/api/admin/ips', window.location.origin);
      if (query) url.searchParams.set('q', query);
      const res = await fetch(url.pathname + url.search, { credentials: 'include' });
      if (!res.ok) {
        setErr('无法获取 IP 列表');
        setRows([]);
        return;
      }
      const data = await res.json();
      setRows(data.items || []);
    } catch {
      setErr('无法获取 IP 列表');
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(''); }, []);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 className="h1">IPs</h2>
        <p className="subtle">按 IP 聚合的访问情况（含问答次数与最近访问时间）。</p>
      </div>

      <div className="glass cardPad">
        <div className="toolbar" style={{ marginBottom: 12 }}>
          <input
            className="input"
            placeholder="搜索 IP（包含匹配）"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            style={{ flex: 1, minWidth: 240 }}
          />
          <button className="pillBtn" onClick={() => load(q)} disabled={loading}>
            {loading ? '加载中…' : '搜索'}
          </button>
        </div>

        {err ? <div style={{ marginBottom: 12 }}><span className="tag tagWarn">{err}</span></div> : null}

        <table>
          <thead>
            <tr>
              <th>IP</th>
              <th>位置</th>
              <th>最近访问</th>
              <th>问答次数</th>
              <th>下载简历</th>
              <th>停留时间</th>
              <th>限流次数</th>
              <th>今日剩余</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.ip}>
                <td>{r.ip}</td>
                <td className="small">{r.location || '—'}</td>
                <td className="small">{r.last_seen ? new Date(r.last_seen * 1000).toLocaleString() : '—'}</td>
                <td>{r.chat_count ?? 0}</td>
                <td>
                  {r.download_count
                    ? <span className="tag tagSuccess">已下载{r.download_count > 1 ? ` (${r.download_count})` : ''}</span>
                    : <span className="small">—</span>
                  }
                </td>
                <td className="small">{formatDuration(r.stay_seconds)}</td>
                <td>{r.rate_limited_count ?? 0}</td>
                <td>{typeof r.remaining_requests === 'number' ? r.remaining_requests : '—'}</td>
              </tr>
            ))}
            {!rows.length ? (
              <tr>
                <td colSpan={8} className="small" style={{ padding: 14 }}>暂无数据</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}


